import { request } from "../../../../../apis";
import { getCurrency } from "../../../../../plugins/utils";
const CURRENCY = getCurrency();

export const getNewRegister = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/report/agent/overview/new/register`,
    {
      ...params,
      page,
    },
    true,
    false
  );

export const getFirstDeposit = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/report/agent/overview/first/deposit`,
    {
      ...params,
      page,
    },
    true,
    false
  );

export const getDepositBet = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/report/agent/overview/deposit/bet`,
    {
      ...params,
      page,
    },
    true,
    false
  );
